(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity/assets/javascripts/api-calls/api-call.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity/assets/javascripts/api-calls/api-call.js');

'use strict';

const GET = 'GET';
const API_PATHS = svs.isServer ? require('../../../../shared-constants/assets/javascripts/api-paths.es6') : svs.lyckoplatsen.components.shared_constants.API_PATHS;
const logger = svs.isServer ? require('trinidad-core').core.logger('module:lyckoplatsen') : svs.lyckoplatsen.logger;
const jupiter = svs.isServer ? require('trinidad-core').core.jupiter : svs.core.jupiter;
async function fetchFromAPI(path, method, req) {
  try {
    const result = await jupiter.callAsync({
      path,
      method,
      req
    });
    return result;
  } catch (error) {
    logger.error("Failed to get data from API at path: ".concat(path), error);
    throw error;
  }
}
async function fetchCharityPayouts(req) {
  let drawNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (drawNumber) {
    return fetchFromAPI(API_PATHS.charityPayoutsByDraws(drawNumber), GET, req);
  }
  return fetchFromAPI(API_PATHS.charityPayouts(), GET, req);
}
async function fetchActiveCharities(req) {
  return fetchFromAPI(API_PATHS.charities(), GET, req);
}
async function fetchCharityById(charityId, req) {
  return fetchFromAPI(API_PATHS.charityById(charityId), GET, req);
}
async function fetchCharityPayoutsWithCharities(req) {
  let drawNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  const activeCharities = await fetchActiveCharities(req);
  const charityPayouts = await fetchCharityPayouts(req, drawNumber);
  return {
    activeCharities,
    charityPayouts
  };
}
async function postSelectCharity(_ref) {
  let {
    clientSerial,
    charityId
  } = _ref;
  const toApi = {
    retailerCustomerId: 0,
    productId: 'GEO1',
    clientSerial,
    charityId
  };
  const res = await jupiter.callAsync({
    path: API_PATHS.selectCharity(),
    method: 'POST',
    data: toApi
  });
  return res;
}
async function postCharitySub(_ref2) {
  let {
    subscrId,
    charityId
  } = _ref2;
  const toApi = {
    subscriptionId: subscrId,
    charityId
  };
  const res = await jupiter.callAsync({
    path: API_PATHS.changeSubscriptionCharity(),
    method: 'POST',
    data: toApi
  });
  return res;
}
if (svs.isServer) {
  module.exports = {
    fetchActiveCharities,
    fetchCharityById,
    fetchCharityPayouts,
    fetchCharityPayoutsWithCharities
  };
} else {
  Object.assign(svs.lyckoplatsen.components.shared_charity.api_calls, {
    fetchActiveCharities,
    fetchCharityById,
    fetchCharityPayouts,
    fetchCharityPayoutsWithCharities,
    postSelectCharity,
    postCharitySub
  });
}

 })(window);